/**
 * Removes maintainer-only "Publishing on cimmple.com" content from the public Help hub.
 * That section belongs in the Payroll repo for authors, not on the marketing site.
 */
export function stripHelpHubReadmePublishingSection(markdown: string): string {
  const normalized = markdown.replace(/\r\n/g, "\n");
  return normalized.replace(
    /\n## Publishing on cimmple\.com\n[\s\S]*?\n---\n+/,
    "\n"
  );
}
